<div class="end-cap" [ngClass]="wrapperClass">
  <button pButton pRipple type="button" (click)="triggerClick($event)" [icon]="showLoader ? 'app-loading-ring' : icon" [ngClass]="pointerClass" [disabled]="disabled" [label]="label"
          [attr.aria-label]="ariaLabel || label || null" [pTooltip]="tooltip"><ng-content></ng-content></button>
  <button pButton pRipple type="button" *ngIf="secondButton && !menuItems.length"
          [icon]="secondButtonIcon"
          [disabled]="disabled"
          [ngClass]="secondButtonPointerClass"
          [label]="secondButtonLabel"
          [attr.aria-label]="secondButtonAriaLabel || secondButtonLabel || null"
          [pTooltip]="secondButtonTooltip"
          [iconPos]="'right'"
          (click)="triggerSecondButtonClick($event)"
  ></button>
  <button pButton pRipple type="button" *ngIf="menuItems.length"
          [icon]='secondButtonIcon'
          [disabled]="disabled"
          [ngClass]="secondButtonPointerClass"
          [label]="secondButtonLabel"
          [attr.aria-label]="secondButtonAriaLabel || secondButtonLabel || null"
          [pTooltip]="secondButtonTooltip"
          [iconPos]="'right'"
          (click)="triggerSecondButtonClick($event, menu)"
  ></button>
  <p-menu #menu [model]="menuItems" [popup]="true" [appendTo]="'body'"></p-menu>
</div>
